/*
 * @Author: zerui.yao
 * @Date: 2022-12-08 15:23:52
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-20 14:15:11
 * @FilePath: /fed-authority/src/router/authority.js
 * @Description:
 */
import loaded from '@/utils/util.import';

export default [
  // 权限管理-首页
  {
    path: '/authority',
    meta: {
      title: 'common.pageTitle.personalPermission',
      keepAlive: false,
      perms: ['authority:view'],
    },
    component: loaded('Authority'),
  },
  {
    path: '/authority/point',
    name: 'AuthorityPoint',
    meta: {
      title: 'common.pageTitle.ppManage',
      keepAlive: true,
      aliveName: 'authorityPoint',
      perms: ['authority:point:view'],
    },
    component: loaded('Authority/point'),
  },
  {
    path: '/authority/menu/list',
    meta: {
      title: 'common.pageTitle.menuManagement',
      keepAlive: false,
      perms: ['authority:menu:view'],
    },
    component: loaded('Authority/menuList'),
  },
  {
    path: '/authority/users',
    name: 'PointUsers',
    meta: {
      title: 'common.pageTitle.permissionUsers',
      keepAlive: false,
      perms: ['authority:point:view'],
    },
    component: loaded('Authority/users'),
  },
  {
    path: '/authority/my',
    name: 'AuthorityMy',
    meta: {
      title: 'common.pageTitle.myPermission',
      keepAlive: false,
      perms: ['authority:my:view'],
    },
    component: loaded('Authority/my'),
  },
  {
    path: '/authority/subordinate',
    meta: {
      title: 'common.pageTitle.subordinate',
      keepAlive: false,
      perms: ['authority:subordinate:view'],
    },
    component: loaded('Authority/subordinate'),
  },
  {
    name: 'authorityRole',
    path: '/authority/role',
    meta: {
      title: 'common.pageTitle.roleManage',
      keepAlive: true,
      aliveName: 'authorityRole',
      perms: ['authority:role:view'],
    },
    component: loaded('Authority/role'),
  },
  {
    path: '/authority/role/detail',
    meta: {
      title: 'common.pageTitle.roleDetail',
      keepAlive: false,
      perms: ['authority:role:view'],
    },
    component: loaded('Authority/roleDetail'),
  },
  {
    path: '/authority/task/detail',
    meta: {
      title: 'common.pageTitle.taskDetail',
      keepAlive: false,
      // perms: ['authority:task:detail'],
    },
    component: loaded('Authority/taskDetail'),
  },
  {
    path: '/authority/task/report',
    meta: {
      title: 'common.pageTitle.checkReport',
      keepAlive: false,
      perms: ['authority:task:report'],
    },
    component: loaded('Authority/taskReport'),
  },
  {
    path: '/authority/group/report',
    meta: {
      title: 'common.pageTitle.groupReport',
      keepAlive: false,
      perms: ['authority:group:report'],
    },
    component: loaded('Authority/groupReport'),
  },
  {
    path: '/authority/group/reportDetail',
    meta: {
      title: 'common.pageTitle.reportDetail',
      keepAlive: false,
      // perms: ['authority:group:reportDetail'],
    },
    component: loaded('Authority/reportDetail'),
  },
  {
    name: 'authorityUsergroups',
    path: '/authority/usergroups',
    meta: {
      title: 'authority:usergroups:view',
      keepAlive: true,
      aliveName: 'authorityUsergroups',
      perms: ['authority:usergroups:view'],
    },
    component: loaded('Authority/userGroups'),
  },
];
